import React from 'react'
import { Box, TextBody } from '@ally/metronome-ui'
import styled from 'styled-components'
import { Private } from '@ally/private'
import { TransactionDetailsWrapper } from '../../../utils/commonStyledComponents'
import { FormattedAmountString } from '../FormattedAmountString'
import { TransactionDetailsData } from '../../../types'

const StyledBox = styled(Box)<{ bottomBorder: boolean | undefined }>`
  ${({ theme, bottomBorder }): string => `
   border-bottom: ${
     bottomBorder ? `1px solid ${theme.colors['slate-2']}` : 'none'
   };
   margin-bottom: ${bottomBorder ? `${theme.space.xl}` : ''}
 `}
`

const PrivateContentCheck: React.FC<{
  isPrivate: boolean | undefined
  content: undefined | React.ReactElement
}> = ({ isPrivate, content }) =>
  isPrivate ? <Private>{content}</Private> : <>{content}</>

export const TransactionDetailsRows: React.FC<{
  data: TransactionDetailsData[]
  bottomBorder?: boolean
}> = ({ data, bottomBorder }) => (
  <StyledBox bottomBorder={bottomBorder} my="md">
    {data.map((transactionDetails, index) => {
      const { heading, content, isAmount, hidden, isPrivate } =
        transactionDetails
      const keyName = `${heading}-${index}`
      if (hidden) return <></>
      if (typeof content !== 'number' && !content)
        return (
          <PrivateContentCheck
            isPrivate={isPrivate}
            content={<Box key={keyName}>{heading}</Box>}
          />
        )

      return (
        <PrivateContentCheck
          isPrivate={isPrivate}
          content={
            <TransactionDetailsWrapper key={keyName}>
              <TextBody size="sm" tag="span" weight="bold" className="heading">
                {heading}
              </TextBody>
              {isAmount && typeof content === 'number' ? (
                <FormattedAmountString
                  value={content}
                  size="sm"
                  isHideErrorColor
                />
              ) : (
                <TextBody size="sm" tag="span">
                  {content}
                </TextBody>
              )}
            </TransactionDetailsWrapper>
          }
        />
      )
    })}
  </StyledBox>
)
